export default class SmartParking {
  id: string = "";
  name: string = "";
  buildingId: string = "";
  parkingAreas: ParkingArea[] = [];

  static parse(obj: any): SmartParking {
    var result = new SmartParking();
    Object.assign(result, obj);
    return result;
  }
}

export class ParkingArea {
  id: string = "";
  name: string = "";
  smartParkingId: string = "";
  taplifeControllerId: string = "";
  availableLots: number = 0;
  parkingLots: ParkingLot[] = [];

  static parse(obj: any): ParkingArea {
    var result = new ParkingArea();
    Object.assign(result, obj);
    return result;
  }
}

export class ParkingLot {
  id: string = "";
  name: string = "";
  parkingNumber: number = 1;
  parkingAreaId: string = "";
  scenarioId?: number | null = null;
  scenarioUId?: string | null = null;
  status: "Available" | "Occupying" | "Occupied" | "OutOfService" | "Reserved" =
    "Available";

  static parse(obj: any): ParkingLot {
    var result = new ParkingLot();
    Object.assign(result, obj);
    return result;
  }
}

export class ReserveModel {
  fullName: string = "";
  phoneNumber: string = "";
  date: Date | string = new Date();
  startTime: string = "";
  endTime: string = "";
  buildingId: string = "";
  smartParkingId: string = "";
  parkingAreaId: string = "";
  // scenarioId?: number | null = null;
  parkingLotId?: string | null = null; // optional
}
export class ReservedModel {
  id: string = "";
  creator: string = "";
  user: string = "";
  userPhoneNumber: string = "";
  submitDate: string = "";
  date: string = "";
  startTime: string = "";
  endTime: string = "";
  enteryDate: string | null = null;
  exitDate: string | null = null;
  state: string = "";
  parkingFullName: string = "";
}
